import { type DependencyList, useEffect } from 'react';

export function useAsyncEffect(effect: () => Promise<any>, deps?: DependencyList) {
  useEffect(() => {
    void effect();
  }, deps);
}
